<template>
    <div class="echarts">
        <div ref="myEchart" class="mapEcharts"></div>
    </div>
</template>
<script>
    import echarts from "echarts";
    import '../../../../../node_modules/echarts/map/js/china.js' // 引入中国地图数据
    export default {
        name: "echarts",
        props: ["userJson"],
        data() {
            return {
                chart: null,
                mapData:[]
            };
        },
        mounted() {
            this.getChinaCodeTree()
        },
        beforeDestroy() {
            if (!this.chart) {
                return;
            }
            this.chart.dispose();
            this.chart = null;
        },
        methods: {
            chinaConfigure() {
                let myChart = echarts.init(this.$refs.myEchart); //这里是为了获得容器所在位置//5566
                window.onresize = myChart.resize;
                myChart.setOption({ // 进行相关配置
                    backgroundColor: "#fff",
                    tooltip: {
                        trigger: 'item',
                        "confine": true,
                        "formatter": (p)=>{//自定义提示信息
                            if(p.value>0){
                                return '经销商数量：'+p.value;
                            }
                        }
                    },//鼠标移到图里面的浮动提示框
                    dataRange: {
                        show: false,
                        min: 0,
                        max: 1000,
                        text: ['High', 'Low'],
                        realtime: true,
                        calculable: true,
                        color: ['orangered', 'yellow', 'lightskyblue']
                    },
                    geo: { // 这个是重点配置区
                        map: 'china', // 表示中国地图
                        roam: true,
                        label: {
                            normal: {
                                show: true, // 是否显示对应地名
                                textStyle: {
                                    color: 'rgba(0,0,0,0.4)'
                                }
                            }
                        },
                        itemStyle: {
                            normal: {
                                borderColor: 'rgba(0, 0, 0, 0.2)'
                            },
                            emphasis: {
                                areaColor: null,
                                shadowOffsetX: 0,
                                shadowOffsetY: 0,
                                shadowBlur: 20,
                                borderWidth: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    },
                    series: [{
                        type: 'scatter',
                        coordinateSystem: 'geo', // 对应上方配置
                        layoutCenter: ['30%', '30%'],
                        layoutSize: 800
                    },
                        {
                            name: '启动次数', // 浮动框的标题
                            type: 'map',
                            geoIndex: 0,
                            data:this.mapData
                        }
                    ]
                })
            },
            getChinaCodeTree(){
                fetch({url: "hcm/chinaCode/getChinaCodeTree", method: "get"})
                    .then((res)=>{
                        let mapArr=[]
                        for(let item of res){
                            if(item.value>0){
                                for(let items of item.children){
                                    if(items.value>0){
                                        if(items.name.indexOf('省')!=-1||items.name.indexOf('市')!=-1){
                                            items.name=items.name.substring(0,items.name.length-1)
                                        }
                                        mapArr.push(items)
                                    }
                                }
                            }

                        }
                        this.mapData=mapArr
                        this.$set(this,"mapData",mapArr);
                        this.chinaConfigure();
                    })
            }
        }
    }
</script>
<style lang="scss">
    .mapEcharts{
         width: 1000px;
         height: 500px;
    }
    @media screen and (max-width: 1400px){
        .mapEcharts{
            width: 600px;
            height: 400px;
        }
    }

</style>
